import AppLayout from "@/layouts/AppLayout.vue";
import AdminFeesManagementView from "@/views/fees/AdminFeesManagementView.vue";
import MandateFeesView from "@/views/fees/MandateFeesView.vue";

export default [
  {
    path: '/fees-management',
    name: 'adminFeesManagement',
    component: AdminFeesManagementView,
    meta: {
      parent: 'fees',
      related: 'adminFeesManagement',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_PLATFORM_FEE']
    }
  },
  {
    path: '/mandate-fees',
    name: 'mandateFees',
    component: MandateFeesView,
    meta: {
      parent: 'fees',
      related: 'mandateFees',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_MANDATE_FEES', 'GET_ADMIN_MANDATE_FEES']
    }
  },
];
